import { Grid } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'src/common/redux/configure-store';
import { ToggleKeypadButton } from 'src/keypad/components/toggle-keypad-button';
import Pagination from 'src/pagination/pagination';
import { styles } from './base-container-styles';

export interface BaseContainerProps {
  isKeypadVisible: boolean | undefined;
  toggleKeypad: () => void;
  currentPage: number;
  totalPages: number;
  updateCurrentPageHandler: (currentPage: number) => void;
}

export const BaseContainer = ({
  isKeypadVisible,
  toggleKeypad,
  currentPage,
  totalPages,
  updateCurrentPageHandler,
  children,
}: React.PropsWithChildren<BaseContainerProps>): JSX.Element => {
  const isLeftHanded = useSelector<AppState, boolean>(state => state.cashierPreferences.leftHanded);
  const classes = styles();

  return (
    <Grid
      container
      direction={isLeftHanded ? 'row-reverse' : 'row'}
      wrap='nowrap'
      justifyContent='space-between'
      alignItems='center'
      className={classes.paginationGridLayout}
    >
      <Grid item container className={classes.paginationWrapper}>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          updateCurrentPageHandler={updateCurrentPageHandler}
          testIdPrefix={'action-window-base'}
        />
      </Grid>
      {children}
      {!isKeypadVisible && (
        <Grid item>
          <ToggleKeypadButton toggleKeypad={toggleKeypad} />
        </Grid>
      )}
    </Grid>
  );
};
